import { AnalyticsField, DashboardWidgetName, FilterComparison, FilterLogic, PivotTableLayout } from '@types'

import { getDefaultLinkedTransactionsAttrs, getDefaultValuePivotAttrs } from '@/views/Dashboards/utils/widget-attrs'
import { generateRandomKey } from '@/helpers'

const PORTFOLIO_DASHBOARD = {
  name: 'Portfolio',
  slug: 'portfolio',
  widgets: [
    {
      id: DashboardWidgetName.ValueHistoryPieChart,
      name: DashboardWidgetName.ValueHistoryPieChart,
      title: 'Value Pie Chart',
      attrs: {},
      sharedProps: true,
    },
    {
      id: DashboardWidgetName.ValueHistoryTable,
      name: DashboardWidgetName.ValueHistoryTable,
      title: 'Value Table',
      attrs: {},
      tall: true,
      sharedProps: true,
    },
    {
      id: DashboardWidgetName.ValueHistoryBarsChart,
      name: DashboardWidgetName.ValueHistoryBarsChart,
      title: 'Value History',
      attrs: {},
      sharedProps: true,
    },
    {
      id: DashboardWidgetName.ValueChangeSnapshot,
      name: DashboardWidgetName.ValueChangeSnapshot,
      title: 'Value Change',
      attrs: {},
      wide: true,
    },
  ],
}

const VALUE_PIVOT_DASHBOARD = {
  name: 'Value Pivot',
  slug: 'value-pivot',
  widgets: [
    {
      id: DashboardWidgetName.ValuePivot,
      name: DashboardWidgetName.ValuePivot,
      title: '',
      attrs: getDefaultValuePivotAttrs(),
      tall: true,
      wide: true,
    },
  ],
}

const COMMITMENTS_DASHBOARD = {
  name: 'Commitments',
  slug: 'commitments',
  widgets: [
    {
      id: DashboardWidgetName.Commitments,
      name: DashboardWidgetName.Commitments,
      title: '',
      attrs: {},
      tall: true,
      wide: true,
    },
  ],
}

const LINKED_TRANSACTIONS_DASHBOARD = {
  name: 'Linked Transactions',
  slug: 'linked-transactions',
  widgets: [
    {
      id: DashboardWidgetName.LinkedTransactions,
      name: DashboardWidgetName.LinkedTransactions,
      title: 'Most recent linked transactions',
      attrs: getDefaultLinkedTransactionsAttrs(),
      wide: true,
    },
    {
      id: DashboardWidgetName.LinkedTransactionsPivot,
      name: DashboardWidgetName.LinkedTransactionsPivot,
      title: '',
      attrs: {},
      tall: true,
      wide: true,
    },
  ],
}

const ASSETS_LIABILITIES_DASHBOARD = {
  name: 'Assets/Liabilities',
  slug: 'assets-liabilities',
  widgets: [
    {
      id: `${DashboardWidgetName.ValuePivot}Assets`,
      name: DashboardWidgetName.ValuePivot,
      title: 'Assets',
      attrs: {
        index: 0,
        configs: [
          {
            name: 'Assets',
            open: true,
            layout: PivotTableLayout.MODERN,
            filter: {
              params: [
                {
                  key: generateRandomKey(),
                  params: [
                    {
                      key: generateRandomKey(),
                      comparison: FilterComparison.GREATER,
                      field: AnalyticsField.POSITION_CLOSE,
                      value: '0',
                      readonly: true,
                    },
                  ],
                  logic: FilterLogic.AND,
                },
              ],
              logic: FilterLogic.AND,
            },
          }
        ]
      },
      tall: true,
    },
    {
      id: `${DashboardWidgetName.ValuePivot}Liabilities`,
      name: DashboardWidgetName.ValuePivot,
      title: 'Liabilities',
      attrs: {
        index: 0,
        configs: [
          {
            name: 'Liabilities',
            open: true,
            layout: PivotTableLayout.MODERN,
            filter: {
              params: [
                {
                  key: generateRandomKey(),
                  params: [
                    {
                      key: generateRandomKey(),
                      comparison: FilterComparison.LESS,
                      field: AnalyticsField.POSITION_CLOSE,
                      value: '0',
                      readonly: true,
                    },
                  ],
                  logic: FilterLogic.AND,
                },
              ],
              logic: FilterLogic.AND,
            },
          }
        ]
      },
      tall: true,
    },
  ],
}

export const CASH_FLOW_PROJECTIONS_DASHBOARD = {
  name: 'Cash Flow Projections',
  slug: 'cash-flow-projections',
  widgets: [
    {
      id: DashboardWidgetName.CashFlowProjections,
      name: DashboardWidgetName.CashFlowProjections,
      title: 'Cash Flow Projections',
      attrs: {
        columns: ['account_name', 'asset_name', 'value'],
        projectionBy: 'month',
      },
      wide: true,
      tall: true,
    },
  ],
}

export const POSSIBLE_DASHBOARDS = [
  PORTFOLIO_DASHBOARD,
  VALUE_PIVOT_DASHBOARD,
  COMMITMENTS_DASHBOARD,
  LINKED_TRANSACTIONS_DASHBOARD,
  ASSETS_LIABILITIES_DASHBOARD,
  CASH_FLOW_PROJECTIONS_DASHBOARD,
]
